import { render, staticRenderFns } from "./CityData.vue?vue&type=template&id=0a53c374&scoped=true"
import script from "./CityData.vue?vue&type=script&lang=js"
export * from "./CityData.vue?vue&type=script&lang=js"
import style0 from "./CityData.vue?vue&type=style&index=0&id=0a53c374&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a53c374",
  null
  
)

export default component.exports